import React from 'react';

const BlogCard = ({post}) => {
    return (
        <div className="col-md-4 mt-5 mb-5" style={{width: '18rem'}}>
            <img src={post.img} className="card-img-top" alt="..."/>
            <div className="card-body" style={{background: 'whitesmoke', borderRadius: '10px', height: '15rem'}}>
                <h5 className="card-title text-color"><b>{post.title}</b></h5>
                <p className="card-text">{post.content}</p>
            </div>
        </div>
    );
};

export default BlogCard;